import script from "./ProductDetailNutritionRateSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailNutritionRateSection.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailNutritionRateSection.vue?vue&type=style&index=0&id=1ecdfd9e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecdfd9e"]])

export default __exports__